import AdminLiveClasses from '../AdminLiveClasses';
import { useI18n } from '../../context/useI18n';
import MastersBackHeader from '../common/MastersBackHeader';

/** Registro de asistencia de la sede (sin programación de clases en vivo). */
export default function GymAttendancePanel({ onBack, scopeGymId = null, scopeGymName = '' }) {
  const { t } = useI18n();

  return (
    <div className="dashboard-main-view surface-readable d28d-admin-surface space-y-4">
      <MastersBackHeader
        onBack={onBack}
        title={t('gym.home.attendance', 'Asistencia')}
      />
      <p className="text-sm text-stone-600 m-0">
        {t(
          'gym.attendance.subtitle',
          'Consulta quién asistió a cada clase de tu sede. Para programar nuevas sesiones, usa Maestros → Clases en vivo.',
        )}
      </p>
      <AdminLiveClasses
        embedded
        attendanceOnly
        scopeGymId={scopeGymId}
        scopeGymName={scopeGymName}
      />
    </div>
  );
}
